(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = this.closest('.t4s-section-header'); // Asegurar que seleccionamos el .section-header correcto
      if (!this.header) this.header = document.querySelector('.section-header'); // Fallback si es necesario
      
      this.headerWrapper = this.closest('.t4s-header__wrapper');
      this.headerIsAlwaysSticky = this.headerWrapper.classList.contains('is--sticky-default') || this.headerWrapper.classList.contains('is--sticky-scrollUp');
      // La lógica original de T4S para sticky es más compleja y está en theme.js.
      // Este JS es del tema Dawn y podría no ser totalmente compatible o necesario si T4S maneja sticky de otra forma.
      // Por ahora, se mantiene la lógica original del tema T4S para sticky (manejada por sus clases y theme.js)
      // y este script de Dawn podría ser redundante o causar conflictos si no se adapta.
      // Por simplicidad y para no romper T4S, este JS de Dawn puede ser eliminado si T4S tiene su propio manejo de sticky.
      // Si se mantiene, hay que asegurar que this.header sea el elemento correcto.
      
      // Si T4S usa su propio JS para sticky, este bloque de abajo puede ser innecesario.
      // Para este ejemplo, lo dejaré comentado para evitar conflictos iniciales.
      /*
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky && this.headerWrapper) { // Check headerWrapper
        this.headerWrapper.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      // ... resto del JS de sticky-header de Dawn ...
      */
    }
    setHeaderHeight() { // Esta función es útil y puede mantenerse
        if(this.header) document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    // ... (Resto de métodos de StickyHeader de Dawn, considerar si son necesarios o si T4S los maneja) ...
    // Por ahora, para evitar conflictos, se omiten los manejadores de scroll de Dawn,
    // asumiendo que el tema T4S ya gestiona el comportamiento sticky.
    // Si no es así, se deberían adaptar o reactivar.
  }
  if (typeof StickyHeader !== 'undefined' && !customElements.get('sticky-header')) { // Evitar redefinir si ya existe
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
